// this test is fallible as we can set a value now,
// but then localStorage can fill up later, so we
// will also set the tracking variable if a setItem
// ever fails.
export const checkLocalStorageAvailable = () => {
  const key = `ls_test_${Date.now()}`;
  try {
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
  } catch (e) {
    return false;
  }
  return true;
};

let localStorageAvailable = checkLocalStorageAvailable();
export const isLocalStorageAvailable = () => localStorageAvailable;

export const setItem = (key: string, value: string, fallback?: () => void) => {
  try {
    localStorage.setItem(key, value);
  } catch (_) {
    localStorageAvailable = false;
    fallback?.();
  }
};

export const getItem = (key: string, fallback?: string) => {
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch (_) {
    return fallback;
  }
};

export const deleteItem = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (_) {
    // do nothing
  }
};
